import { render } from "./layout.vue?vue&type=template&id=42452ef2&ts=true"
import script from "./layout.vue?vue&type=script&lang=ts&config=true"
export * from "./layout.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__